//eslint-disable-next-line
export const SECRET_REGEX_PATTERN = "^(?=.*[A-ZŠĐŽĆČ])(?=.*[a-zšđžćč])(?=.*[0-9])(?=.*[\\.:,;#?!@$%^&*+\\-]).{8,}$";